import React from 'react';
import Card from '@mui/material/Card';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CardContent,
  Divider,
} from '@mui/material';
import EventDetailsGrid from './EventDetailsGrid';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useState } from 'react';
import SchoolTitleHeader from './SchoolTitleHeader';
import { Event } from '../../model/event';
import { useMediaQuery } from 'react-responsive';
interface IProps {
  eventDetails?: Event;
  eventDates?: string;
}

const EventDetailsExpansionPanel = React.memo(
  function EventDetailsExpansionPanel({ eventDetails, eventDates }: IProps) {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' });
    const [expanded, setExpanded] = useState(isTabletOrMobile ? false : true);

    const handleChange = () => {
      setExpanded(!expanded);
    };

    const headerFields = {
      schoolName: eventDetails?.schoolName,
      date: eventDates,
    };
    return (
      <Card sx={{ mb: 4 }}>
        <SchoolTitleHeader headerFields={headerFields} />
        <CardContent sx={{ p: 0 }}>
          <Accordion elevation={0} expanded={expanded} disableGutters>
            <AccordionSummary sx={{ display: 'none' }}></AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <EventDetailsGrid eventDetails={eventDetails} />
              <Divider variant='middle'></Divider>
            </AccordionDetails>
          </Accordion>
        </CardContent>
        <Box sx={{ textAlign: 'end', m: 1 }} onClick={handleChange}>
          {expanded ? (
            <Button
              sx={{ textTransform: 'unset' }}
              endIcon={<ExpandLessIcon />}
            >
              Hide Event Details
            </Button>
          ) : (
            <Button
              sx={{ textTransform: 'unset' }}
              endIcon={<ExpandMoreIcon />}
            >
              Show Event Details
            </Button>
          )}
        </Box>
      </Card>
    );
  },
  (prevProps, nextProps) =>
    prevProps.eventDetails?.status === nextProps.eventDetails?.status &&
    prevProps.eventDetails?.eventId === nextProps.eventDetails?.eventId
);

export default EventDetailsExpansionPanel;
